import { useSVGContext } from '../../../../../../contexts/GraphicContext';
import { useFlatsDataContext } from '../../../../../../contexts/FlatsDataContext';
import { TFlat } from '../../../../../../shared/types/flat';
import { mapFlatStatusClass, mapFlatStatusText, mapFloorNumber } from '../../../../../../shared/mappers/mappers';

import styles from './SingleFlatRow.module.css';
import { paths } from '../../../../../../settings';

type TSingleFlatRow = {
    flat: TFlat
    isHovered: boolean
}

const SingleFlatRow: React.FC<TSingleFlatRow> = ({ flat, isHovered }): JSX.Element => {
    const { handleContextFlatClick } = useSVGContext();
    const { setContextSelectedFlat, setContextHoveredFlat } = useFlatsDataContext();

    /**
     * Handles the click event on a Flat element, setting it as the selected Flat in the Context.
     * @returns {void}
     */
    const handleClick = (): void => {
        setContextSelectedFlat(flat);
        handleContextFlatClick(flat);
    };

    /**
     * Handles the mouse enter event (hover) on a Flat element, setting it as the currently hovered Flat in the Context.
     * @returns {void}
    */
    const handleMouseEnter = (): void => setContextHoveredFlat(flat);

    /**
     * Handles the mouse leave event on a Flat element, clearing the hovered Flat in the Context.
     * @returns {void}
    */
    const handleMouseLeave = (): void => setContextHoveredFlat({ name: '' });
    
    return (
        <tr role="button" onClick={handleClick} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className={isHovered ? styles.hovered : ''}>
            <td>{flat.name.toUpperCase()}</td>
            <td className={styles[mapFlatStatusClass(flat.status)]}>{mapFlatStatusText(flat.status)}</td>
            <td>{mapFloorNumber(flat.floor.slug)}</td>
            <td>{flat.rooms}</td>
            <td>{flat.area}m<sup>2</sup></td>
            <td className={styles.actions}>
                <img src={`${paths.assets}/icons/arrow_next.png`} alt="PDF" width={20} height={20} />
            </td>
        </tr>
    );
};

export default SingleFlatRow;